import React, { useState, useEffect, useContext } from "react";
import AppContext from "../../../container/context";
import peij from "../../../services/peij";
import { formatDateTime } from "../../../helpers/helpers";
import { CircularProgress } from "@mui/material";
import Form from "../../../components/form";

const TokenGeracao = (props) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [usuarioId] = useState(props.match.params.usuarioId);
  const [usuarioTokenPagamento, setUsuarioTokenPagamento] = useState({});
  const [linkGerado, setLinkGerado] = useState("");

  useEffect(() => {
    if (usuarioId === 0) {
      notification("error", "Usuário inválido.");
      return;
    }
    carregarUsuarioToken();
  }, [usuarioId]);

  const carregarUsuarioToken = () => {
    setCarregando(true);

    peij
      .post("assinaturas/carregarUsuarioTokenPagamento", { usuarioId })
      .then((usuarioTokenPagamento) => {
        if (usuarioTokenPagamento.tokenPagamentoCodigo) {
          let link = `https://checkout.inglesjuntos.com.br/purchase/${usuarioTokenPagamento.tokenPagamentoCodigo}`;
          setLinkGerado(link);
        }
        setUsuarioTokenPagamento(usuarioTokenPagamento);
        setCarregando(false);
      })
      .catch((e) =>
        notification("error", "Não foi possível validar o usuário: " + e)
      );
  };

  const gerarUsuarioToken = (form) => {
    const tokenGerar = {
      usuarioId: usuarioTokenPagamento.usuarioId,
      valor: (form.valor * 100).toFixed(0),
      maxParcelas: form.maxParcelas,
      duracaoAssinatura: form.duracaoAssinatura,
      validade: form.validade,
    };

    peij
      .post("assinaturas/gerarTokenPagamento", tokenGerar)
      .then((result) => {
        if (result.codigo) {
          let link = `https://checkout.inglesjuntos.com.br/purchase/${result.codigo}`;
          setLinkGerado(link);
        }
      })
      .catch((err) => {
        console.log(err);
        notification(
          "error",
          "Não foi possível gerar o token. Verifique as informações."
        );
      });
  };

  const camposToken = (usuarioTokenPagamento) => {
    const campos = {
      usuarioNome: {
        label: "Nome do usuário",
        type: "text",
        value: usuarioTokenPagamento.usuarioNome,
        readOnly: true,
        space: 6,
      },
      usuarioEmail: {
        label: "Email",
        type: "text",
        value: usuarioTokenPagamento.usuarioEmail,
        readOnly: true,
        space: 6,
      },
    };

    if (linkGerado === "") {
      campos.valor = {
        label: "Valor R$",
        type: "number",
        value: usuarioTokenPagamento.valor,
        space: 3,
        required: true,
      };
      campos.maxParcelas = {
        label: "Máximo de parcelas",
        type: "number",
        value: usuarioTokenPagamento.maxParcelas,
        space: 3,
        required: true,
      };
      campos.duracaoAssinatura = {
        label: "Duração da assinatura (meses)",
        type: "number",
        value: usuarioTokenPagamento.mesesAssinatura,
        space: 3,
        required: true,
      };
      campos.validade = {
        label: "Validade do link de pagamento",
        type: "date",
        value: usuarioTokenPagamento.validade
          ? formatDateTime(usuarioTokenPagamento.validade, "Y-M-D")
          : null,
        required: true,
        space: 3,
      };
    } else {
      campos.label = {
        label: "Link para pagamento",
        type: "component",
        value: <h4>O usuário possui um token ativo. Link para pagamento:</h4>,
      };
      campos.link = {
        label: "Link para pagamento",
        type: "component",
        value: (
          <a
            target="_blank"
            href={linkGerado}
            style={{ marginBottom: 15 }}
            rel="noreferrer"
          >
            {linkGerado}
          </a>
        ),
      };
    }

    return campos;
  };

  const fToken = {
    title: linkGerado ? "Token gerado" : "Gerar token de pagamento",
    form: camposToken(usuarioTokenPagamento),
    submit: linkGerado
      ? {
          label: "Editar token",
          action: () =>
            props.history.push(
              `/app/token-pagamento-ij/${usuarioTokenPagamento.tokenPagamentoCodigo}`
            ),
        }
      : {
          label: "Salvar",
          action: gerarUsuarioToken,
        },
    close: {},
    history: props.history,
  };

  return (
    <div>{carregando ? <CircularProgress /> : <Form formData={fToken} />}</div>
  );
};

export default TokenGeracao;
